import { Dialog } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledDialog = styled(Dialog)(({ theme, fullScreen }) => ({
  ".MuiDialog-paper": {
    maxHeight: fullScreen ? "unset" : "85%",
  },
  "& .MuiDialogTitle-root": {
    paddingTop: theme.spacing(3),
    paddingBottom: 0,
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    "&+.MuiDialogContent-root": {
      paddingTop: theme.spacing(2),
    },
  },
  "& .MuiDialogContent-root": {
    padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
  },
  "& .MuiDialogActions-root": {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },
}));

export { StyledDialog as Dialog };
